import EventResource from '@/resource/EventResource.js'
import BetResource from '@/resource/BetResource.js'
import UsersResource from '@/resource/UsersResource.js'
import LanguagesResource from '@/resource/LanguagesResource.js'

export default class Resource {
  #resource_adaptor
  #app
  #events
  #bets
  #users
  #languages
  constructor(resource_adaptor) {
    this.#resource_adaptor = resource_adaptor
  }

  /**
   *
   * @returns iResource
   */
  events() {
    if (!this.#events) {
      this.#events = new EventResource(this.#resource_adaptor)
    }
    return this.#events
  }

  /**
   *
   * @returns iResource
   */
  bets() {
    if (!this.#bets) {
      this.#bets = new BetResource(this.#resource_adaptor)
    }
    return this.#bets
  }

  /**
   *
   * @returns iResource|UsersResource
   */
  users() {
    if (!this.#users) {
      this.#users = new UsersResource(this.#resource_adaptor)
    }
    return this.#users
  }

  languages() {
    if (!this.#languages) {
      this.#languages = new LanguagesResource(this.#resource_adaptor)
    }
    return this.#languages
  }
  getPrevious() {
    return this.#resource_adaptor.getPrevious()
  }
  signIn(login, password) {
    return this.#resource_adaptor.signIn(login, password)
  }

  signUp(name, login, password) {
    return this.#resource_adaptor.signUp(name, login, password)
  }
  install(app) {
    this.#app = app
    app.config.globalProperties.$resource = this
  }
  getToken() {
    return this.#resource_adaptor.getToken()
  }

  get(url) {
    return this.#resource_adaptor.get(url)
  }
  post(url, data) {
    return this.#resource_adaptor.post(url, data)
  }
  put(url, data) {
    return this.#resource_adaptor.put(url, data)
  }
  patch(url, data) {
    return this.#resource_adaptor.put(url, data)
  }
  delete(url) {
    return this.#resource_adaptor.delete(url)
  }
}


